export const CONFLUENCE_RECAP_ONBOARDING_STATE_KEYS = {
	HAS_SEEN_PUBLISH_SPOTLIGHT: 'confluence-recap:hasSeenPublishSpotlight',
} as const;

export const ConfluenceRecapOnboardingKeys = [
	...Object.values(CONFLUENCE_RECAP_ONBOARDING_STATE_KEYS),
] as const;
